// extracted by mini-css-extract-plugin
module.exports = {"video":"_1Tuctcx9jurwbWVNsCc7fs","backButton":"_3ZodNhKRrImnhlbE-zppkz"};